export default function loadWebComponents() {
  const basePath = window.location.href.replace(/\/host.*/, '');
  // Tworzymy <script src="/ścieżka/nmo/pubWebCmp/index.js?v=1" type="application/javascript"></script>
  const scriptEl = document.createElement('script');
  scriptEl.setAttribute('src', `${basePath}/nmo/pubWebCmp/index.js?v=1`);
  scriptEl.setAttribute('type', 'application/javascript');
  document.body.appendChild(scriptEl);
}
